export const CLOSE_SIGNAL = 'close';

export const REPLAY_VIDEO_SIGNAL = 'replayCurrentVideo';

export const NEXT_VIDEO_SIGNAL = 'playNextVideo';

export const NEXT_VIDEO_COUNTDOWN = 10;
